import script from "./BulkAssignLeadsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkAssignLeadsDialog.vue?vue&type=script&setup=true&lang=js"

import "./BulkAssignLeadsDialog.vue?vue&type=style&index=0&id=002217ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002217ae"]])

export default __exports__